import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navData: [{
      name: "飞讯平台",
      path: "/",
      isActive: "active"
    }, {
      name: "系统演示",
      path: "/system",
      isActive: ""
    }, {
      name: "关于我们",
      path: "http://www.feixuns.com",
      isActive: ""
    }],
    nav2Data: [{
        name: "组装行业",
        to: "/show/",
        isActive: "active"
      },
      {
        name: "离散制造",
        to: "/show/assemble",
        isActive: ""
      },
      {
        name: "注塑行业",
        to: "/show/molding",
        isActive: ""
      }
    ],
    nav3Data: [{
        name: "APP平台",
        to: "/videoList/",
        isActive: "active"
      },
      {
        name: "BS平台",
        to: "/videoList/bs",
        isActive: ""
      },
      {
        name: "CS平台",
        to: "/videoList/cs",
        isActive: ""
      },
      {
        name: "行业标准产品",
        to: "/videoList/product",
        isActive: ""
      }
    ],
    subject: "feixun"
  },
  mutations: {

  },
  actions: {},
  modules: {}

})